const config = {
  //server_ip: "http://127.0.0.1:4000",
  server_ip: "https://invoiceapi.phormuladev.com",
};

export default config;
